import * as React from 'react';
import PropTypes from 'prop-types';
import classname from 'classnames';
import { Button } from 'zarm';
import { action } from '@iyunbao/cr-engine';

import { BaseWidgetProps } from '../utils/type';
import { isInApp, throttle } from '../utils/tools';

type OptionsProps = Array<{
  label: string;
  type?: 'button' | 'text' | 'price' | 'allN';
  name?: string;
  flex?: number;
  hidden?: boolean;
  isApp?: boolean;
  className?: string;
  action?: any;
  prefixCls?: string;
  desc?: string;
}>;

export interface TabsProps extends BaseWidgetProps {
  // value?: any;
  type?: 'group';
  allNDisabled?: boolean;
  allNSelected?: boolean;
  options: OptionsProps;
  className?: string;
  prefixCls?: string;
  desc?: string;
}

interface TabsState {}

interface BottomBarState {
  isSelected: boolean;
}

class BottomBar extends React.Component<TabsProps, TabsState> {
  static propTypes = {
    prefixCls: PropTypes.string,
  };

  static defaultProps = {
    prefixCls: 'crm-bottom-bar',
  };
  
  state: BottomBarState = {
    isSelected: false,
  };

  componentDidMount() {
    const { allNSelected } = this.props;

    this.setState({ isSelected: allNSelected});
  }

  componentWillReceiveProps(nextProps) {
    const { allNSelected } = nextProps;

    this.setState({ isSelected: allNSelected});
  }

  onAction(item: any) {
    const { onChange, onLog, _crengine = {}, allNDisabled } = this.props;
    const { action: waction } = _crengine;
    const { log, type: itemType } = item;
    const { isSelected } = this.state;

    if (!allNDisabled && itemType === 'allN') {
      this.setState({isSelected: !isSelected});
      item.isAllN = !isSelected;
    }

    onChange && onChange(item);

    // 用于埋点标记，回调
    if (log && onLog) {
      onLog && onLog(log);
    }

    if (!item.action) {
      return false;
    }

    if (waction) {
      waction(item.action);
      return false;
    }

    const { type, data } = item.action;

    if (action[type]) {
      action[type](data);
      return false;
    }
  }

  renderItem(item: any) {
    const { prefixCls, allNDisabled } = this.props;

    const {
      type = 'text',
      theme = 'default',
      label,
      value,
      // 前缀单位
      prefix,
      // 后缀单位
      suffix,
    } = item;

    const cls = classname(`${prefixCls}-${type}`);
    const allNCls = classname(`${prefixCls}-${type}`, {[`${prefixCls}-${type}-disabled`]: allNDisabled});
    const { isSelected } = this.state;

    switch (type) {
      // 按钮
      case 'button':
        return (
          <Button block shape="round" theme={theme} className={cls}>
            {label}
          </Button>
        );
      // 价格
      case 'price':
        return (
          <div className={cls}>
            {label ? <span className="price-label">{label}</span> : null}
            {prefix ? <span className="price-prefix">{prefix}</span> : null}
            <span className="price-number">{value}</span>
            {suffix ? <span className="price-suffix">{suffix}</span> : null}
          </div>
        );
      // 以上全否 http://jira.baoyun.ltd/browse/APP-9946
      case 'allN':
        return (
          <div className={allNCls}>
            <img src={`http://static.iyb.tm/web/h5/iyb-components-mobile/icon-${allNDisabled ? 'gray' : (isSelected ? 'selected' : 'unselected')}.png`} alt="" />
            <span>以上全否</span>
          </div>
        );
      default:
        return <div className={cls}>{label}</div>;
    }
  }

  render() {
    const { prefixCls, type, options, className, desc } = this.props;

    if (!(options && Array.isArray(options) && options.length)) {
      return null;
    }

    const opts = options.filter((item) => !(item.hidden || (typeof item.isApp !== 'undefined' && item.isApp !== isInApp)));
    const buttonLen = opts.filter((item) => item.type === 'button').length;

    const cls = classname(prefixCls, className, {
      [`${prefixCls}-${type}`]: type === 'group' && buttonLen === 2,
    });

    return (
      <div className={cls}>
        <div className={`${prefixCls}-fixed`}>
          {desc && <div className={`${prefixCls}-fixed-desc`}>{desc}</div>}
          <div className={`${prefixCls}-inner`}>
            {opts.map((item: any, key) => (
              <div
                className={classname(`${prefixCls}-item`, item.className, {
                  [`${prefixCls}-item-${item.type}`]: !!item.type,
                  [`item-flex-${item.flex}`]: !!item.flex,
                })}
                key={`${item.name || 'item'}_${key}`}
                onClick={throttle(() => this.onAction(item))}
              >
                {this.renderItem(item)}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default BottomBar;
